// extracted by mini-css-extract-plugin
export var gif = "_dx-0";